/**
 * flat list를 key 기준으로 묶는다. 현장카드 데이터(현장보고·중요알림)가 배치 API로
 * flat list로 오기 때문에, siteId별로 나눠 각 카드에 붙일 때 공용으로 쓴다.
 */
export function groupBy<T, K>(items: T[], keyOf: (item: T) => K): Map<K, T[]> {
  const map = new Map<K, T[]>();
  for (const item of items) {
    const key = keyOf(item);
    const bucket = map.get(key);
    if (bucket) bucket.push(item);
    else map.set(key, [item]);
  }
  return map;
}
